<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <p>Completar Información</p>
  <button mat-mini-fab (click)="close(false)"><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content [ngClass]="{'loading': loading}">
  <div class="ctn-loading" *ngIf="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <mat-stepper orientation="vertical">
    <mat-step
      [stepControl]="formStep1"
      errorMessage="Verifique el formulario"
      (interacted)="interseptedStep1()"
    >
      <ng-template matStepLabel>Propiedad</ng-template>
      <form class="mt-12" [formGroup]="formStep1">
        <div fxLayout="row" class="mb-12">
          <mat-slide-toggle formControlName="is_moral" (change)="moralInquilino($event)">Es una persona moral</mat-slide-toggle>
        </div>

        <div fxLayout="row" class="mb-24">
          <mat-slide-toggle formControlName="with_representate" (change)="withRepresentateInquilino($event)">Cuenta con un representante legal</mat-slide-toggle>
        </div>
        
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Instrumento público número</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_instrumento_publico"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker1"
                formControlName="fecha_registro"
              >
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Licenciado que dio fe</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="licenciado"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Notaría pública</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_notaria_publica"
              >
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Ciudad de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="ciudad_registro"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Folio mercantil electrónico</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="folio_mercantil"
              >
            </mat-form-field>
          </div>
        </div>
      </form>

      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="formStep2">
      <ng-template matStepLabel>Representante Legal</ng-template>

      <form [formGroup]="formStep2">
        <div fxLayout="row" class="mb-24 mt-12">
          <mat-slide-toggle formControlName="is_moral" (change)="moralRepreInquilino($event)">Es una persona moral</mat-slide-toggle>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Nombre Completo</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="full_name"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Instrumento público número</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_instrumento_publico"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker2"
                formControlName="fecha_registro"
              >
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Licenciado que dio fe</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="licenciado"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Notaría pública</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_notaria_publica"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">  
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Ciudad de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="ciudad_registro"
              >
            </mat-form-field>
          </div>
        </div>
      </form>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button matStepperPrevious class="preview">Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="formStep3">
      <ng-template matStepLabel>Obligado Solidario</ng-template>

      <form [formGroup]="formStep3">
        <div fxLayout="row" class="mb-24 mt-12">
          <mat-slide-toggle formControlName="is_moral" (change)="moralObligadoSolidario($event)">Es una persona moral</mat-slide-toggle>
        </div>

        <div fxLayout="row" class="mb-24 mt-12">
          <mat-slide-toggle formControlName="with_representate" (change)="withRepresentateObligado($event)">Cuenta con un representante legal</mat-slide-toggle>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Nombre Completo</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="full_name"
              >
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Email</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="email"
              >
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Dirección completa</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="full_address"
              >
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Dirección de la Propiedad</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="property_address"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Instrumento público número</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_instrumento_publico"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker4"
                formControlName="fecha_registro"
              >
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Licenciado que dio fe</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="licenciado"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Notaría pública</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_notaria_publica"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Ciudad de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="ciudad_registro"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Folio Mercantil</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="folio_mercantil"
              >
            </mat-form-field>
          </div>
        </div>
      </form>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button matStepperPrevious class="preview">Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Representante Legal</ng-template>
        
        <form [formGroup]="formStep4">
          <div fxLayout="row" class="mb-24 mt-12">
            <mat-slide-toggle formControlName="is_moral" (change)="moralRepreObligado($event)">Es una persona moral</mat-slide-toggle>
          </div>
  
          <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
            <div fxFlex="100%" fxFlexFill fxLayout="column">
              <label class="input">Nombre Completo</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="full_name"
                >
              </mat-form-field>
            </div>
          </div>
    
          <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Instrumento público número</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="no_instrumento_publico"
                >
              </mat-form-field>
            </div>
    
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Fecha de Registro</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  [matDatepicker]="picker5"
                  formControlName="fecha_registro"
                >
                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                <mat-datepicker #picker5></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
    
          <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Licenciado que dio fe</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="licenciado"
                >
              </mat-form-field>
            </div>
    
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Notaría pública</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="no_notaria_publica"
                >
              </mat-form-field>
            </div>
          </div>
    
          <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">  
            <div fxFlex="100%" fxFlexFill fxLayout="column">
              <label class="input">Ciudad de Registro</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="ciudad_registro"
                >
              </mat-form-field>
            </div>
          </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-button matStepperPrevious class="preview">Anterior</button>
          <button
            mat-button
            matStepperNext
            [disabled]="loadingSubmit"
            (click)="submit()"
            *ngIf="!loadingSubmit"
          >Finalizar</button>
          <mat-spinner [diameter]="30" *ngIf="loadingSubmit"></mat-spinner>
        </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>